module.exports = __webpack_public_path__ + "fc08f9ff2db64eeb1ed8e87ac8ac1c25.png";